<script lang="ts">
    
    import { Icon } from "sveltestrap";
    import type { Game } from "../../Model/Game";
    import GameTypeText from "./GameTypeText.svelte";
    import { toCanvas } from "qrcode";
    import { CLIENT_URL } from "../../environment";

    export let game: Game = undefined;
    let canvas: HTMLCanvasElement;
    let showQrModal: boolean = false;

    function showQr() {
        showQrModal = !showQrModal;
        
        createCanvas();
    }

    function createCanvas() {
        if(game) {
            const roomUrl = new URL(`/room/${game.roomId}?gameCode=${game.code}`, CLIENT_URL);

            toCanvas(canvas, roomUrl.href, {
                width: 300,
            });
        }
    }

    function toggleShowQrModal(): void {
        showQrModal = !showQrModal;
    }

</script>

{#if game}
    <div class="game-meta-info">
        <div class="game">
            <div class="type"><GameTypeText type={game.type} /></div>
            <div class="code">{game.code}</div>
        </div>
        <button on:click={showQr}>
            <Icon name="qr-code" />
        </button>
        <div class="figure-check">
            <!-- <FigureCheck check={game.useCheckers} /> -->
        </div>
    </div>

    <div class="position-container" hidden={!showQrModal}>
        <div class="centered-div">
            <button on:click={toggleShowQrModal}><Icon name='x' /></button>
            <div class='qr'>
                <canvas width="300" height="300" bind:this={canvas}></canvas>
                <div class="game-code">
                    <div class="code-modal">{game.code || '----'}</div>
                </div>
            </div>
        </div>
    </div>
{/if}

<style lang="scss">
    .position-container::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5); /* Semi-transparent backdrop */
        z-index: 10;
    }

    /* Centered div */
    .centered-div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        display: flex;
        flex-direction: column;
        background-color: white;
        padding: 20px;
        border-radius: 15px;
        width: 65%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        button {
            align-self: end;
            background-color: transparent;
            border: 0px transparent
        }
    }

    .game-code {
        margin: 2vw 0;

        .code-modal {
            border: 0.4vw solid #00152E;
            color: #00152E;
            font-size: 5vw;
            padding: 0 2vw;
            border-radius: 1vw;
            text-align: center;
        }
    }
    

    .game-meta-info {
        display: flex;
        gap: 0.5rem;
        align-items: center;
    }

    .type {
        font-size: 0.8rem;
    }

    .code {
        font-size: 1.5rem;
        line-height: 1em;
    }

</style>
